<template>
  <div id="opened_filter">
    <div class="flex flex-col gap-2 px-3 py-1">
      <span class="secondary_color text-[13px]">
        Number of times opened(Minimum)
      </span>
      <a-input-number
        ref="openedFilterInput"
        placeholder="Enter number"
        type="number"
        class="w-full"
        v-model:value="inputValue"
        :min="0"
        @change="debouncedApply"
        :controls="false"
      />
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, watch } from "vue";
import debounce from "lodash/debounce.js";

const props = defineProps({
  source: { type: String, required: true },
  currentValue: { type: [String, Number], default: null },
});

const emit = defineEmits(["update:openedFilterChange"]);

const inputValue = ref(null);
const openedFilterInput = ref(null);

const handleApply = () => {
  if (Number(inputValue?.value) > 0) {
    emit("update:openedFilterChange", {
      source: props.source,
      value: Number(inputValue.value),
    });
  } else if (inputValue.value === null || inputValue.value === "") {
    emit("update:openedFilterChange", {
      source: props.source,
      value: null,
    });
  }
};

const debouncedApply = debounce(handleApply, 500);

watch(
  () => props.currentValue,
  (newValue) => {
    inputValue.value = newValue == null ? null : Number(newValue);
  },
  { immediate: true }
);

const focusInput = () => {
  setTimeout(() => {
    if (openedFilterInput.value && openedFilterInput.value.focus) {
      openedFilterInput.value.focus();
    }
  }, 100);
};

onMounted(() => {
  focusInput();
});
</script>
